export default __webpack_public_path__ + "static/media/PerfectWellness Logo big-01.0efc5f39.png";